<template>
  <van-popup
    :value="value"
    position="center"
    class="popup-wrap"
    :close-on-click-overlay="false"
  >
    <div class="wrap">
      <div class="title">手机号登陆后使用</div>
      <van-form class="login-form" ref="formRef">
        <van-field
          class="field-input"
          placeholder="请输入手机号"
          v-model="phone"
          :rules="[
            {
              required: true,
              message: '请输入手机号',
            },
            {
              pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
              message: '请输入正确的11位手机号',
            },
          ]"
        />
        <div class="get-code">
          <van-field
            class="field-input"
            v-model="code"
            placeholder="请输入验证码"
            :rules="[{ required: true, message: '请输入验证码' }]"
          />
          <div
            v-ans="{ event_id: 'validate_code_click', type: 'login' }"
            :class="{ code: true, countDown: countDown > 0 }"
            @click="getVerifyCode"
          >
            {{ countDown > 0 ? `${countDown}s` : "获取验证码" }}
          </div>
        </div>
      </van-form>
      <div class="btn" native-type="submit" @click="handleLogin">立即登陆</div>
    </div>
  </van-popup>
</template>

<script>
import { defineComponent, ref } from "@vue/composition-api";
import Vue from "vue";

import { useStore, useRoute } from "@/components/use/base";

import { register, multiCardLogin } from "@/apis/home";

const vm = Vue.prototype;

export default defineComponent({
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const phone = ref("");
    const code = ref("");
    const countDown = ref(0);
    const sessionCode = ref("");
    const timer = ref(null);
    const formRef = ref(null);

    const store = useStore();
    const route = useRoute();

    const { namespace_group } = route.query;

    const getVerifyCode = async () => {
      if (countDown.value > 0) {
        return;
      }
      if (!phone.value) {
        vm.$toast("请输入手机号");
        return;
      }
      if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(phone.value)) {
        vm.$toast("请输入正确的11位手机号");
        return;
      }

      const toast = vm.$loading("发送中");
      try {
        const { session_code } = await register({
          phone_number: phone.value,
          app_name: vm.$getConfigValue("APP_NAME"),
        });
        countDown.value = 60;
        sessionCode.value = session_code;
        timer.value = setInterval(() => {
          countDown.value--;
          if (countDown.value == 0) {
            clearInterval(timer.value);
          }
        }, 1000);
      } finally {
        toast.clear();
      }
    };

    const handleLogin = async () => {
      await formRef.value.validate();
      const { data } = await multiCardLogin({
        phone_number: phone.value,
        code: code.value,
        session_code: sessionCode.value,
        namespace_group: namespace_group,
      });
      const token = data.token;
      store.commit("changeState", { token, ptoken: token });
      emit("close", false);
      emit("handleLogin");
    };

    return {
      phone,
      code,
      countDown,
      sessionCode,
      formRef,
      getVerifyCode,
      handleLogin,
    };
  },
});
</script>

<style scoped lang="less">
.popup-wrap {
  width: 332px;
  background: #fff;
  border-radius: 8px;
}

.wrap {
  height: 338px;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;

  .title {
    margin-top: 24px;
    font-family: AppleSystemUIFont;
    font-size: 16px;
    color: #000000;
    line-height: 18px;
    text-align: center;
  }

  .login-form {
    padding: 0 20px;
    margin-top: 24px;
  }

  .get-code {
    position: relative;

    .code {
      position: absolute;
      right: 16px;
      top: 12px;
      width: 80px;
      line-height: 40px;
      height: 26px;
      text-align: center;
      font-size: 12px;
      color: #0091ff;
      box-sizing: border-box;
      &.countDown {
        color: #0091ff;
      }
    }
  }

  .field-input {
    &::after {
      content: none;
    }
    /deep/.van-field__body {
      background: #f5f5f5;
      height: 46px;
      margin: 0 -12px;
      padding: 0 12px;
    }

    /deep/ .van-field__error-message {
      margin: 0 -12px;
    }

    /deep/ input {
      &::placeholder {
        color: #999999 !important;
      }
    }
  }

  .btn {
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    width: 294px;
    height: 44px;
    background: linear-gradient(134deg, #483122 0%, rgba(18, 0, 0, 0.87) 100%);
    border-radius: 22px;

    font-weight: 500;
    font-size: 16px;
    color: #f0dbbc;
    line-height: 44px;
    text-align: center;
  }
}
</style>
